<is-wait-message [loadComplete]="pageLoadComplete()" [useBolt]="false" [waitMessage]="'Please wait while we process your request.'" [timeoutAmount]="0">
</is-wait-message>

<router-outlet></router-outlet>